import { render, staticRenderFns } from "./ProductEditForm.vue?vue&type=template&id=41cef0c8&scoped=true"
import script from "./ProductEditForm.vue?vue&type=script&lang=js"
export * from "./ProductEditForm.vue?vue&type=script&lang=js"
import style0 from "./ProductEditForm.vue?vue&type=style&index=0&id=41cef0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cef0c8",
  null
  
)

export default component.exports